module.exports = __webpack_public_path__ + "img/index9.5e1e7c36.png";